import React from 'react';
import affinipayIcon from "../../../assets/icons/workIcons/affinipayIcon.svg";

function AffinipayIcon() {
    return ( 
        <img className="tab-icon" src={affinipayIcon} alt="affinipayIcon.svg"/>
    );
}

export default AffinipayIcon;